import WarningBanner from './WarningBanner';

export default WarningBanner;
